import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LeaveRequestCalculationResponse  {
    _originalTypeClassName = "zERP.BO.LeaveRequestCalculationResponse";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LeaveRequestCalculationResponse.translate = translateService;
}
this.WorkingDays = 0;
this.InsuredDays = 0;
this.DateTo = null;
this.WorkingHours = 0;
this.LeaveRequestCalculationResponseKey = null;
this._key = this.LeaveRequestCalculationResponseKey = 0; 
}

static translate: TranslateService;
_key: any;
WorkingDays:any;
InsuredDays:any;
DateTo:any;
WorkingHours:any;
private _LeaveRequestCalculationResponseKey:any;
get LeaveRequestCalculationResponseKey(): any {
    return this._LeaveRequestCalculationResponseKey;
  }
set LeaveRequestCalculationResponseKey(value: any) {
    this._LeaveRequestCalculationResponseKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.LeaveRequestCalculationResponseKey == null || $this.LeaveRequestCalculationResponseKey == 0;
            }


}